<template>
	<div class="container">
		<div class="common-header-wrap">
		<mt-header class="common-header" title="Password assistance">
			<mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
		</mt-header>
		</div>
			<div class="container">
				<div class="section-wrapper top-wrapper">
				<div>
					<mt-field class="input-wrapper" v-model="username_email" placeholder="Please enter your email address" />
				</div>
				<mt-field class="input-wrapper" placeholder="Verification Code" v-model="verifyCodeMobile_email" type="number"  :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" >
					<mt-button @click="sendVerifyCodeEmail" class="btn" type="default" size="small" plain>{{sendStateTextMobile_email}}</mt-button>
				</mt-field>
			</div>
			<div class="section-wrapper bottom-wrapper">
				<div>
					<mt-field
							class="input-wrapper"
							type="password"
							v-model="password_email"
							placeholder="Enter new password"
							maxlength="20"
					/>
				</div>
				<div>
					<mt-field type="password" class="input-wrapper" v-model="confirmPassword_email" placeholder="Re-enter new password" maxlength="20"/>
				</div>
			</div>
			<label class="tips">6-20 digit number/letter/symbol</label>
			<mt-button type="primary" class="ds-button-large mt-10" v-on:click="onemailSubmit">Save changes</mt-button>
			</div>

	</div>
</template>

<script>
import { forget,getemailcode,forgetemail } from '../../../api/memberForget'
import { getSmsCaptcha } from '../../../api/common'
import { mapMutations, mapActions, mapState } from 'vuex'
import { Toast } from 'mint-ui'
export default {
  name: 'HomeMemberForget',
  components: {
  },
  data () {
    return {
      username_email: '',
      password_email: '',
      confirmPassword_email: '',
      verifyCodeMobile_email: '',
      canSendMobile_email: true,
      timeIntervalMobile_email: false,
      sendStateTextMobile_email: 'Send Out'
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timeIntervalMobile_email)
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),
    //  发送邮箱验证码
	sendVerifyCodeEmail:function(){
		var regemail = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9-_]+\.([a-zA-Z0-9-_.]{2,10})$/;
		if(this.username_email==""){
			Toast("Please enter your email address");
    		return false;
		}else if(!regemail.test(this.username_email)){
			Toast("Please enter the correct email address");
    		return false;
		}else{
			if (!this.canSendMobile_email) {
	        	return
	        }
			getemailcode(this.username_email).then(res => {
		        this.canSendMobile_email = false
		        let second = 60
		        Toast("Sent")
		        let _this = this
		        this.timeIntervalMobile_email = setInterval(function () {
		          if (second <= 0) {
		            _this.canSendMobile_email = true
		            _this.sendStateTextMobile_email = 'Send Out'
		            clearInterval(_this.timeIntervalMobile_email)
		          }else{
					  _this.sendStateTextMobile_email = second + 's'
				  }
		          second--
		        }, 1000)
		      }).catch(function (error) {
		        Toast(error.message)
		      })
		}
	},
	//邮箱找回密码提交
	onemailSubmit:function(){
		var regemail = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9-_]+\.([a-zA-Z0-9-_.]{2,10})$/;
		if(this.username_email==""){
			Toast("Please enter your email address");
    		return false;
		}else if(!regemail.test(this.username_email)){
			Toast("Please enter the correct email address");
    		return false;
		}else if(this.verifyCodeMobile_email==""){
			Toast("Please enter the email verification code");
    		return false;
		}else if(this.password_email==""){
			Toast("Please input a password");
    		return false;
		}else if(this.password_email.length<6 || this.password_email.length>20){
			Toast("Please enter a 6-20 digit password");
    		return false;
		}else if(this.password_email!=this.confirmPassword_email){
			Toast("The password and confirmation password are inconsistent");
    		return false;
		}else{
			forgetemail(this.username_email,this.verifyCodeMobile_email,this.password_email).then(res => {
				if(res.code==10000){
					Toast("Password modification succeeded");
					this.$router.push({ name: 'HomeMemberLogin'})
				}else{
					Toast(res.message)
				}
			}).catch(function (error) {
		        Toast(error.message)
		    })
		}
	}
  }
}
</script>

<style scoped lang="scss">
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		background-color: #f0f2f5;
		.section-wrapper {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: stretch;
			background-color: #ffffff;
			border-top: 1px solid #e8eaed;
			border-bottom: 1px solid #e8eaed;
			.input-wrapper {
				display: flex;
				flex-direction: row;
				align-content: flex-start;
				align-items: center;
				background-color: #fff;
				height:2.2rem;
				padding-left:0.5rem;
				input {
					flex: 1;
					font-size:.7rem
				}
				.bottom-input {
					border-bottom-width: 0;
				}
			}
		}
	}
	.top-wrapper {
		margin-top: 0.5rem;
	}
	.bottom-wrapper {
		margin-top: 0.5rem;
	}
	.tips {
		color: #c3c3c3;
		font-size: 0.6rem;
		margin-left: 0.9rem;
		margin-top: 0.5rem;
		text-align: left;
	}
	.countdown {
		width: 5.6rem;
		height: 1.5rem;
		margin-left: 0.5rem;
		margin-right: 0.5rem;
	}
</style>
